function Images(){
    return(
        <div className="w-full h-full">
            <div className="grid grid-cols-2 gap-6">

            <img src='https://i.pinimg.com/736x/3d/22/95/3d2295868d35641febd56180b0574899.jpg'
             className="w-full h-96 object-cover"/>
            <img src='https://i.pinimg.com/736x/75/c4/9c/75c49cf8bf11ee4898038ebeb5c28434.jpg'
             className="w-full h-96 object-cover"/>
            </div>
        </div>
    )
}
export default Images